export default {"src":"/_next/static/media/LogoIpsum4.f32c4041.svg","height":32,"width":175,"blurWidth":0,"blurHeight":0};